/**
 * @flow
 * @relayHash 7fcb043f4f1d8208462302ca06657e82
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type GenerateVideoInput = {|
  eventId?: ?string,
  startnumber: string,
|};
export type GenerateVideoMutationVariables = {|
  input: GenerateVideoInput
|};
export type GenerateVideoMutationResponse = {|
  +generateVideo: ?{|
    +url: ?string
  |}
|};
export type GenerateVideoMutation = {|
  variables: GenerateVideoMutationVariables,
  response: GenerateVideoMutationResponse,
|};
*/


/*
mutation GenerateVideoMutation(
  $input: GenerateVideoInput!
) {
  generateVideo(input: $input) {
    url
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "GenerateVideoInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "generateVideo",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "GenerateVideoPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "url",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "GenerateVideoMutation",
    "type": "RootMutationType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "GenerateVideoMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "GenerateVideoMutation",
    "id": null,
    "text": "mutation GenerateVideoMutation(\n  $input: GenerateVideoInput!\n) {\n  generateVideo(input: $input) {\n    url\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2998df5a09b668d334a9aa2b41f64d1a';

module.exports = node;
